import { ShieldAlert } from "lucide-react";
import Reveal from "./Reveal";

export const FraudWarning = () => {
  return (
    <section data-testid="fraud-warning-section" className="py-16 lg:py-24 bg-[#fdfbf6]">
      <div className="mx-auto max-w-2xl px-6">
        <Reveal>
          <div className="mb-8 text-center sm:text-left">
            <h2 className="font-display text-4xl sm:text-5xl text-[#0a0a0a]">
              Beware of <span className="text-[#c1272d]">fraud</span>
            </h2>
            <div className="mx-auto sm:mx-0 mt-4 flex items-center justify-center sm:justify-start gap-2">
              <span className="h-1.5 w-12 rounded-full bg-[#c1272d]" />
              <span className="h-1.5 w-6 rounded-full bg-[#f5b301]" />
              <span className="h-1.5 w-3 rounded-full bg-[#29abe2]" />
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div
            data-testid="fraud-warning-card"
            className="relative overflow-hidden rounded-3xl border border-[#c1272d]/25 bg-[#c1272d]/[0.05] p-6 sm:p-8"
          >
            <span className="absolute left-0 top-6 h-[calc(100%-3rem)] w-1.5 rounded-full bg-[#c1272d]" />
            <div className="flex items-start gap-4 pl-2">
              <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#c1272d]/12 text-[#c1272d]">
                <ShieldAlert size={20} />
              </span>
              <div>
                <p className="text-lg leading-relaxed text-[#0a0a0a] font-medium">
                  Several fraudulent websites have been falsely claiming to
                  represent Hotel Kohinoor.
                </p>
                <p className="mt-4 text-base leading-relaxed text-[#52525b]">
                  Please do <span className="font-semibold text-[#c1272d]">not</span> trust
                  any bookings, payments, or communications made through those
                  sites. Only the verified contact details listed on this page
                  are official.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FraudWarning;
